import '.bp{flex-shrink:0;}.ssr-plugin'
import '.br{padding:1rem;}.ssr-plugin'
import '.t{width:100%;}.ssr-plugin'
import '.bg{height:100%;}.ssr-plugin'
import '.az{border:none;}.ssr-plugin'
import '.b0{background-color:transparent;}.ssr-plugin'
import '.fm{border-radius:0px;}.ssr-plugin'
import '.g{display:flex;}.ssr-plugin'
import '.h{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.dj{position:sticky;}.ssr-plugin'
import '.fn{top:4rem;}.ssr-plugin'
import '.fo{z-index:7;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.fp{padding-bottom:1rem;}.ssr-plugin'
import '.c{margin-bottom:1rem;}.ssr-plugin'
import '.fq{border-bottom:var(--blue-border);}.ssr-plugin'
import '.o{position:fixed;}.ssr-plugin'
import '.cf{top:0;}.ssr-plugin'
import '.be{left:0px;}.ssr-plugin'
import '.bf{right:0px;}.ssr-plugin'
import '.fr{bottom:0px;}.ssr-plugin'
import '.d6{z-index:9999;}.ssr-plugin'
import '.fs{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.cv{justify-content:flex-end;}.ssr-plugin'
import '.bt{flex:1;}.ssr-plugin'
import '.al{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bp br t bg az b0 fm"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="g h ab"
    >
      <div className="dj fn fo ae fp c fq g"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="o cf be bf fr d6 ae fs g h"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="br g cv fq"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="bt al">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
